import React, { createContext, useContext, useState, useEffect } from 'react';

// Translations for all supported languages
const translations = {
  en: {
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    loading: 'Loading...',
    actions: 'Actions',
    yes: 'Yes',
    no: 'No',
    confirm: 'Confirm',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    clear: 'Clear',
    filter: 'Filter',
    reset: 'Reset',
    view: 'View',
    print: 'Print',
    download: 'Download',
    share: 'Share',
    
    // Navigation
    dashboard: 'Dashboard',
    pos: 'POS',
    products: 'Products',
    cashRegister: 'Cash Register',
    expenses: 'Expenses',
    grnEntry: 'GRN Entry',
    stockManagement: 'Stock Management',
    customerLedger: 'Customer Ledger',
    supplierLedger: 'Supplier Ledger',
    billsHistory: 'Bills History',
    reports: 'Reports',
    settings: 'Settings',
    logout: 'Logout',
    
    // Settings Menu
    businessProfile: 'Business Profile',
    categorySettings: 'Category Settings',
    taxGroupSettings: 'Tax Group Settings',
    supplierSettings: 'Supplier Settings',
    customerSettings: 'Customer Settings',
    cashierSettings: 'Cashier Settings',
    expenseCategories: 'Expense Categories',
    billSettings: 'Bill Settings',
    unitSettings: 'Unit Settings',
    languageSettings: 'Language Settings',
    
    // POS Billing
    billing: 'Billing',
    searchProducts: 'Search products...',
    cart: 'Cart',
    emptyCart: 'Cart is empty',
    addItemsToStart: 'Add items to start billing',
    quantity: 'Qty',
    price: 'Price',
    total: 'Total',
    subtotal: 'Subtotal',
    discount: 'Discount',
    tax: 'Tax',
    grandTotal: 'Grand Total',
    payNow: 'Pay Now',
    holdBill: 'Hold Bill',
    clearCart: 'Clear Cart',
    customer: 'Customer',
    selectCustomer: 'Select Customer',
    guest: 'Guest',
    addNewCustomer: 'Add New Customer',
    estimation: 'Estimation',
    estimationMode: 'Estimation Mode',
    stockNotAffected: 'Stock won\'t be affected',
    createEstimation: 'Create Estimation',
    
    // Payment
    payment: 'Payment',
    paymentMode: 'Payment Mode',
    cash: 'Cash',
    card: 'Card',
    upi: 'UPI',
    credit: 'Credit',
    amountPaid: 'Amount Paid',
    changeReturn: 'Change Return',
    completePayment: 'Complete Payment',
    
    // Products
    productName: 'Product Name',
    sku: 'SKU',
    barcode: 'Barcode',
    category: 'Category',
    mrp: 'MRP',
    basePrice: 'Base Price',
    sellingPrice: 'Selling Price',
    currentStock: 'Current Stock',
    stockAlert: 'Stock Alert',
    taxGroup: 'Tax Group',
    addProduct: 'Add Product',
    editProduct: 'Edit Product',
    noProducts: 'No products found',
    
    // Cash Register
    openRegister: 'Open Register',
    closeRegister: 'Close Register',
    openingBalance: 'Opening Balance',
    closingBalance: 'Closing Balance',
    expectedBalance: 'Expected Balance',
    actualBalance: 'Actual Balance',
    difference: 'Difference',
    registerStatus: 'Register Status',
    registerClosed: 'Register Closed',
    registerOpen: 'Register Open',
    
    // Expenses
    expenseDate: 'Date',
    expenseCategory: 'Category',
    expenseAmount: 'Amount',
    expenseDescription: 'Description',
    addExpense: 'Add Expense',
    noExpenses: 'No expenses found',
    
    // GRN
    grnNumber: 'GRN Number',
    supplier: 'Supplier',
    invoiceNumber: 'Invoice Number',
    invoiceDate: 'Invoice Date',
    addItem: 'Add Item',
    saveGRN: 'Save GRN',
    
    // Ledger
    balance: 'Balance',
    debit: 'Debit',
    creditAmount: 'Credit',
    recordPayment: 'Record Payment',
    paymentHistory: 'Payment History',
    totalReceivable: 'Total Receivable',
    totalPayable: 'Total Payable',
    
    // Bills History
    billNumber: 'Bill No.',
    estimationNumber: 'Estimation No.',
    dateTime: 'Date & Time',
    items: 'Items',
    bills: 'Bills',
    estimations: 'Estimations',
    fromDate: 'From Date',
    toDate: 'To Date',
    noBillsFound: 'No bills found',
    noEstimationsFound: 'No estimations found',
    
    // Form Fields
    name: 'Name',
    mobile: 'Mobile',
    email: 'Email',
    address: 'Address',
    city: 'City',
    gstNumber: 'GST Number',
    pin: 'PIN',
    
    // Messages
    successSaved: 'Saved successfully',
    successDeleted: 'Deleted successfully',
    errorOccurred: 'An error occurred',
    confirmDelete: 'Are you sure you want to delete?',
    
    // Print
    taxInvoice: 'TAX INVOICE',
    estimationDoc: 'ESTIMATION',
    billTo: 'Bill To',
    gstSummary: 'GST Summary',
    cgst: 'CGST',
    sgst: 'SGST',
    thankYou: 'Thank you for your purchase!',
    poweredBy: 'Powered by GPOS',
    
    // Language
    selectLanguage: 'Select Language',
    languageChanged: 'Language changed successfully',
  },
  
  ta: {
    // Common - Tamil
    save: 'சேமி',
    cancel: 'ரத்து செய்',
    delete: 'நீக்கு',
    edit: 'திருத்து',
    add: 'சேர்',
    search: 'தேடு',
    loading: 'ஏற்றுகிறது...',
    actions: 'செயல்கள்',
    yes: 'ஆம்',
    no: 'இல்லை',
    confirm: 'உறுதிப்படுத்து',
    close: 'மூடு',
    back: 'பின்னால்',
    next: 'அடுத்து',
    submit: 'சமர்ப்பி',
    clear: 'அழி',
    filter: 'வடிகட்டு',
    reset: 'மீட்டமை',
    view: 'பார்',
    print: 'அச்சிடு',
    download: 'பதிவிறக்கு',
    share: 'பகிர்',
    
    // Navigation
    dashboard: 'டாஷ்போர்டு',
    pos: 'POS',
    products: 'பொருட்கள்',
    cashRegister: 'பண பதிவகம்',
    expenses: 'செலவுகள்',
    grnEntry: 'GRN பதிவு',
    stockManagement: 'சரக்கு மேலாண்மை',
    customerLedger: 'வாடிக்கையாளர் லெட்ஜர்',
    supplierLedger: 'சப்ளையர் லெட்ஜர்',
    billsHistory: 'பில் வரலாறு',
    reports: 'அறிக்கைகள்',
    settings: 'அமைப்புகள்',
    logout: 'வெளியேறு',
    
    // Settings Menu
    businessProfile: 'வணிக விவரம்',
    categorySettings: 'வகை அமைப்புகள்',
    taxGroupSettings: 'வரி குழு அமைப்புகள்',
    supplierSettings: 'சப்ளையர் அமைப்புகள்',
    customerSettings: 'வாடிக்கையாளர் அமைப்புகள்',
    cashierSettings: 'காசியர் அமைப்புகள்',
    expenseCategories: 'செலவு வகைகள்',
    billSettings: 'பில் அமைப்புகள்',
    unitSettings: 'அலகு அமைப்புகள்',
    languageSettings: 'மொழி அமைப்புகள்',
    
    // POS Billing
    billing: 'பில்லிங்',
    searchProducts: 'பொருட்களை தேடு...',
    cart: 'கூடை',
    emptyCart: 'கூடை காலியாக உள்ளது',
    addItemsToStart: 'பில்லிங் தொடங்க பொருட்களை சேர்க்கவும்',
    quantity: 'அளவு',
    price: 'விலை',
    total: 'மொத்தம்',
    subtotal: 'உப மொத்தம்',
    discount: 'தள்ளுபடி',
    tax: 'வரி',
    grandTotal: 'மொத்த தொகை',
    payNow: 'இப்போது செலுத்து',
    holdBill: 'பில் நிறுத்து',
    clearCart: 'கூடை அழி',
    customer: 'வாடிக்கையாளர்',
    selectCustomer: 'வாடிக்கையாளரை தேர்வு செய்',
    guest: 'விருந்தினர்',
    addNewCustomer: 'புதிய வாடிக்கையாளர் சேர்',
    estimation: 'மதிப்பீடு',
    estimationMode: 'மதிப்பீடு முறை',
    stockNotAffected: 'சரக்கு பாதிக்கப்படாது',
    createEstimation: 'மதிப்பீடு உருவாக்கு',
    
    // Payment
    payment: 'கட்டணம்',
    paymentMode: 'கட்டண முறை',
    cash: 'பணம்',
    card: 'கார்டு',
    upi: 'UPI',
    credit: 'கடன்',
    amountPaid: 'செலுத்திய தொகை',
    changeReturn: 'மீதி திருப்பி',
    completePayment: 'கட்டணம் முடி',
    
    // Products
    productName: 'பொருள் பெயர்',
    sku: 'SKU',
    barcode: 'பார்கோடு',
    category: 'வகை',
    mrp: 'MRP',
    basePrice: 'அடிப்படை விலை',
    sellingPrice: 'விற்பனை விலை',
    currentStock: 'தற்போதைய சரக்கு',
    stockAlert: 'சரக்கு எச்சரிக்கை',
    taxGroup: 'வரி குழு',
    addProduct: 'பொருள் சேர்',
    editProduct: 'பொருள் திருத்து',
    noProducts: 'பொருட்கள் இல்லை',
    
    // Cash Register
    openRegister: 'பதிவகம் திற',
    closeRegister: 'பதிவகம் மூடு',
    openingBalance: 'தொடக்க இருப்பு',
    closingBalance: 'முடிவு இருப்பு',
    expectedBalance: 'எதிர்பார்க்கும் இருப்பு',
    actualBalance: 'உண்மை இருப்பு',
    difference: 'வேறுபாடு',
    registerStatus: 'பதிவக நிலை',
    registerClosed: 'பதிவகம் மூடப்பட்டது',
    registerOpen: 'பதிவகம் திறந்துள்ளது',
    
    // Expenses
    expenseDate: 'தேதி',
    expenseCategory: 'வகை',
    expenseAmount: 'தொகை',
    expenseDescription: 'விளக்கம்',
    addExpense: 'செலவு சேர்',
    noExpenses: 'செலவுகள் இல்லை',
    
    // GRN
    grnNumber: 'GRN எண்',
    supplier: 'சப்ளையர்',
    invoiceNumber: 'இன்வாய்ஸ் எண்',
    invoiceDate: 'இன்வாய்ஸ் தேதி',
    addItem: 'பொருள் சேர்',
    saveGRN: 'GRN சேமி',
    
    // Ledger
    balance: 'இருப்பு',
    debit: 'டெபிட்',
    creditAmount: 'கிரெடிட்',
    recordPayment: 'கட்டணம் பதிவு செய்',
    paymentHistory: 'கட்டண வரலாறு',
    totalReceivable: 'மொத்த பெறவேண்டியது',
    totalPayable: 'மொத்த செலுத்த வேண்டியது',
    
    // Bills History
    billNumber: 'பில் எண்',
    estimationNumber: 'மதிப்பீடு எண்',
    dateTime: 'தேதி & நேரம்',
    items: 'பொருட்கள்',
    bills: 'பில்கள்',
    estimations: 'மதிப்பீடுகள்',
    fromDate: 'தொடக்க தேதி',
    toDate: 'முடிவு தேதி',
    noBillsFound: 'பில்கள் இல்லை',
    noEstimationsFound: 'மதிப்பீடுகள் இல்லை',
    
    // Form Fields
    name: 'பெயர்',
    mobile: 'மொபைல்',
    email: 'இமெயில்',
    address: 'முகவரி',
    city: 'நகரம்',
    gstNumber: 'GST எண்',
    pin: 'PIN',
    
    // Messages
    successSaved: 'வெற்றிகரமாக சேமிக்கப்பட்டது',
    successDeleted: 'வெற்றிகரமாக நீக்கப்பட்டது',
    errorOccurred: 'பிழை ஏற்பட்டது',
    confirmDelete: 'நீக்க விரும்புகிறீர்களா?',
    
    // Print
    taxInvoice: 'வரி இன்வாய்ஸ்',
    estimationDoc: 'மதிப்பீடு',
    billTo: 'பில் பெறுநர்',
    gstSummary: 'GST சுருக்கம்',
    cgst: 'CGST',
    sgst: 'SGST',
    thankYou: 'வாங்கியதற்கு நன்றி!',
    poweredBy: 'GPOS மூலம்',
    
    // Language
    selectLanguage: 'மொழி தேர்வு செய்',
    languageChanged: 'மொழி மாற்றப்பட்டது',
  },
  
  hi: {
    // Common - Hindi
    save: 'सेव करें',
    cancel: 'रद्द करें',
    delete: 'हटाएं',
    edit: 'संपादित करें',
    add: 'जोड़ें',
    search: 'खोजें',
    loading: 'लोड हो रहा है...',
    actions: 'कार्रवाई',
    yes: 'हाँ',
    no: 'नहीं',
    confirm: 'पुष्टि करें',
    close: 'बंद करें',
    back: 'पीछे',
    next: 'आगे',
    submit: 'जमा करें',
    clear: 'साफ करें',
    filter: 'फ़िल्टर',
    reset: 'रीसेट',
    view: 'देखें',
    print: 'प्रिंट',
    download: 'डाउनलोड',
    share: 'शेयर',
    
    // Navigation
    dashboard: 'डैशबोर्ड',
    pos: 'POS',
    products: 'उत्पाद',
    cashRegister: 'कैश रजिस्टर',
    expenses: 'खर्चे',
    grnEntry: 'GRN एंट्री',
    stockManagement: 'स्टॉक प्रबंधन',
    customerLedger: 'ग्राहक खाता',
    supplierLedger: 'सप्लायर खाता',
    billsHistory: 'बिल इतिहास',
    reports: 'रिपोर्ट',
    settings: 'सेटिंग्स',
    logout: 'लॉगआउट',
    
    // Settings Menu
    businessProfile: 'व्यापार प्रोफाइल',
    categorySettings: 'श्रेणी सेटिंग्स',
    taxGroupSettings: 'टैक्स ग्रुप सेटिंग्स',
    supplierSettings: 'सप्लायर सेटिंग्स',
    customerSettings: 'ग्राहक सेटिंग्स',
    cashierSettings: 'कैशियर सेटिंग्स',
    expenseCategories: 'खर्च श्रेणियां',
    billSettings: 'बिल सेटिंग्स',
    unitSettings: 'इकाई सेटिंग्स',
    languageSettings: 'भाषा सेटिंग्स',
    
    // POS Billing
    billing: 'बिलिंग',
    searchProducts: 'उत्पाद खोजें...',
    cart: 'कार्ट',
    emptyCart: 'कार्ट खाली है',
    addItemsToStart: 'बिलिंग शुरू करने के लिए आइटम जोड़ें',
    quantity: 'मात्रा',
    price: 'मूल्य',
    total: 'कुल',
    subtotal: 'उप कुल',
    discount: 'छूट',
    tax: 'कर',
    grandTotal: 'कुल राशि',
    payNow: 'अभी भुगतान करें',
    holdBill: 'बिल होल्ड',
    clearCart: 'कार्ट साफ करें',
    customer: 'ग्राहक',
    selectCustomer: 'ग्राहक चुनें',
    guest: 'अतिथि',
    addNewCustomer: 'नया ग्राहक जोड़ें',
    estimation: 'अनुमान',
    estimationMode: 'अनुमान मोड',
    stockNotAffected: 'स्टॉक प्रभावित नहीं होगा',
    createEstimation: 'अनुमान बनाएं',
    
    // Payment
    payment: 'भुगतान',
    paymentMode: 'भुगतान मोड',
    cash: 'नकद',
    card: 'कार्ड',
    upi: 'UPI',
    credit: 'उधार',
    amountPaid: 'भुगतान राशि',
    changeReturn: 'वापसी',
    completePayment: 'भुगतान पूरा करें',
    
    // Products
    productName: 'उत्पाद नाम',
    sku: 'SKU',
    barcode: 'बारकोड',
    category: 'श्रेणी',
    mrp: 'MRP',
    basePrice: 'मूल मूल्य',
    sellingPrice: 'बिक्री मूल्य',
    currentStock: 'वर्तमान स्टॉक',
    stockAlert: 'स्टॉक अलर्ट',
    taxGroup: 'टैक्स ग्रुप',
    addProduct: 'उत्पाद जोड़ें',
    editProduct: 'उत्पाद संपादित करें',
    noProducts: 'कोई उत्पाद नहीं',
    
    // Cash Register
    openRegister: 'रजिस्टर खोलें',
    closeRegister: 'रजिस्टर बंद करें',
    openingBalance: 'शुरुआती शेष',
    closingBalance: 'समापन शेष',
    expectedBalance: 'अपेक्षित शेष',
    actualBalance: 'वास्तविक शेष',
    difference: 'अंतर',
    registerStatus: 'रजिस्टर स्थिति',
    registerClosed: 'रजिस्टर बंद है',
    registerOpen: 'रजिस्टर खुला है',
    
    // Expenses
    expenseDate: 'तारीख',
    expenseCategory: 'श्रेणी',
    expenseAmount: 'राशि',
    expenseDescription: 'विवरण',
    addExpense: 'खर्च जोड़ें',
    noExpenses: 'कोई खर्च नहीं',
    
    // GRN
    grnNumber: 'GRN नंबर',
    supplier: 'सप्लायर',
    invoiceNumber: 'इनवॉइस नंबर',
    invoiceDate: 'इनवॉइस तारीख',
    addItem: 'आइटम जोड़ें',
    saveGRN: 'GRN सेव करें',
    
    // Ledger
    balance: 'शेष',
    debit: 'डेबिट',
    creditAmount: 'क्रेडिट',
    recordPayment: 'भुगतान दर्ज करें',
    paymentHistory: 'भुगतान इतिहास',
    totalReceivable: 'कुल प्राप्य',
    totalPayable: 'कुल देय',
    
    // Bills History
    billNumber: 'बिल नं.',
    estimationNumber: 'अनुमान नं.',
    dateTime: 'तारीख और समय',
    items: 'आइटम',
    bills: 'बिल',
    estimations: 'अनुमान',
    fromDate: 'से तारीख',
    toDate: 'तक तारीख',
    noBillsFound: 'कोई बिल नहीं मिला',
    noEstimationsFound: 'कोई अनुमान नहीं मिला',
    
    // Form Fields
    name: 'नाम',
    mobile: 'मोबाइल',
    email: 'ईमेल',
    address: 'पता',
    city: 'शहर',
    gstNumber: 'GST नंबर',
    pin: 'PIN',
    
    // Messages
    successSaved: 'सफलतापूर्वक सेव किया गया',
    successDeleted: 'सफलतापूर्वक हटाया गया',
    errorOccurred: 'एक त्रुटि हुई',
    confirmDelete: 'क्या आप वाकई हटाना चाहते हैं?',
    
    // Print
    taxInvoice: 'कर चालान',
    estimationDoc: 'अनुमान',
    billTo: 'बिल प्राप्तकर्ता',
    gstSummary: 'GST सारांश',
    cgst: 'CGST',
    sgst: 'SGST',
    thankYou: 'खरीदारी के लिए धन्यवाद!',
    poweredBy: 'GPOS द्वारा संचालित',
    
    // Language
    selectLanguage: 'भाषा चुनें',
    languageChanged: 'भाषा सफलतापूर्वक बदली गई',
  },
  
  te: {
    // Common - Telugu
    save: 'సేవ్ చేయి',
    cancel: 'రద్దు చేయి',
    delete: 'తొలగించు',
    edit: 'మార్చు',
    add: 'జోడించు',
    search: 'వెతుకు',
    loading: 'లోడ్ అవుతోంది...',
    actions: 'చర్యలు',
    yes: 'అవును',
    no: 'లేదు',
    confirm: 'నిర్ధారించు',
    close: 'మూసివేయి',
    back: 'వెనుకకు',
    next: 'తదుపరి',
    submit: 'సమర్పించు',
    clear: 'క్లియర్',
    filter: 'ఫిల్టర్',
    reset: 'రీసెట్',
    view: 'చూడు',
    print: 'ప్రింట్',
    download: 'డౌన్‌లోడ్',
    share: 'షేర్ చేయి',
    
    // Navigation
    dashboard: 'డాష్‌బోర్డ్',
    pos: 'POS',
    products: 'ఉత్పత్తులు',
    cashRegister: 'క్యాష్ రిజిస్టర్',
    expenses: 'ఖర్చులు',
    grnEntry: 'GRN ఎంట్రీ',
    stockManagement: 'స్టాక్ నిర్వహణ',
    customerLedger: 'కస్టమర్ లెడ్జర్',
    supplierLedger: 'సప్లయర్ లెడ్జర్',
    billsHistory: 'బిల్లుల చరిత్ర',
    reports: 'నివేదికలు',
    settings: 'సెట్టింగ్‌లు',
    logout: 'లాగ్అవుట్',
    
    // Settings Menu
    businessProfile: 'వ్యాపార ప్రొఫైల్',
    categorySettings: 'వర్గం సెట్టింగ్‌లు',
    taxGroupSettings: 'పన్ను గ్రూప్ సెట్టింగ్‌లు',
    supplierSettings: 'సప్లయర్ సెట్టింగ్‌లు',
    customerSettings: 'కస్టమర్ సెట్టింగ్‌లు',
    cashierSettings: 'క్యాషియర్ సెట్టింగ్‌లు',
    expenseCategories: 'ఖర్చు వర్గాలు',
    billSettings: 'బిల్ సెట్టింగ్‌లు',
    unitSettings: 'యూనిట్ సెట్టింగ్‌లు',
    languageSettings: 'భాష సెట్టింగ్‌లు',
    
    // POS Billing
    billing: 'బిల్లింగ్',
    searchProducts: 'ఉత్పత్తులను వెతుకు...',
    cart: 'కార్ట్',
    emptyCart: 'కార్ట్ ఖాళీగా ఉంది',
    addItemsToStart: 'బిల్లింగ్ ప్రారంభించడానికి ఐటమ్‌లు జోడించండి',
    quantity: 'పరిమాణం',
    price: 'ధర',
    total: 'మొత్తం',
    subtotal: 'ఉప మొత్తం',
    discount: 'తగ్గింపు',
    tax: 'పన్ను',
    grandTotal: 'గ్రాండ్ టోటల్',
    payNow: 'ఇప్పుడు చెల్లించు',
    holdBill: 'బిల్ హోల్డ్',
    clearCart: 'కార్ట్ క్లియర్',
    customer: 'కస్టమర్',
    selectCustomer: 'కస్టమర్ ఎంచుకోండి',
    guest: 'అతిథి',
    addNewCustomer: 'కొత్త కస్టమర్ జోడించు',
    estimation: 'అంచనా',
    estimationMode: 'అంచనా మోడ్',
    stockNotAffected: 'స్టాక్ ప్రభావితం కాదు',
    createEstimation: 'అంచనా సృష్టించు',
    
    // Payment
    payment: 'చెల్లింపు',
    paymentMode: 'చెల్లింపు మోడ్',
    cash: 'నగదు',
    card: 'కార్డ్',
    upi: 'UPI',
    credit: 'క్రెడిట్',
    amountPaid: 'చెల్లించిన మొత్తం',
    changeReturn: 'మార్పు తిరిగి',
    completePayment: 'చెల్లింపు పూర్తి చేయి',
    
    // Products
    productName: 'ఉత్పత్తి పేరు',
    sku: 'SKU',
    barcode: 'బార్‌కోడ్',
    category: 'వర్గం',
    mrp: 'MRP',
    basePrice: 'బేస్ ధర',
    sellingPrice: 'అమ్మకపు ధర',
    currentStock: 'ప్రస్తుత స్టాక్',
    stockAlert: 'స్టాక్ అలర్ట్',
    taxGroup: 'పన్ను గ్రూప్',
    addProduct: 'ఉత్పత్తి జోడించు',
    editProduct: 'ఉత్పత్తి మార్చు',
    noProducts: 'ఉత్పత్తులు లేవు',
    
    // Cash Register
    openRegister: 'రిజిస్టర్ తెరువు',
    closeRegister: 'రిజిస్టర్ మూసివేయి',
    openingBalance: 'ప్రారంభ బ్యాలెన్స్',
    closingBalance: 'ముగింపు బ్యాలెన్స్',
    expectedBalance: 'ఆశించిన బ్యాలెన్స్',
    actualBalance: 'వాస్తవ బ్యాలెన్స్',
    difference: 'తేడా',
    registerStatus: 'రిజిస్టర్ స్థితి',
    registerClosed: 'రిజిస్టర్ మూసి ఉంది',
    registerOpen: 'రిజిస్టర్ తెరిచి ఉంది',
    
    // Expenses
    expenseDate: 'తేదీ',
    expenseCategory: 'వర్గం',
    expenseAmount: 'మొత్తం',
    expenseDescription: 'వివరణ',
    addExpense: 'ఖర్చు జోడించు',
    noExpenses: 'ఖర్చులు లేవు',
    
    // GRN
    grnNumber: 'GRN నంబర్',
    supplier: 'సప్లయర్',
    invoiceNumber: 'ఇన్వాయిస్ నంబర్',
    invoiceDate: 'ఇన్వాయిస్ తేదీ',
    addItem: 'ఐటమ్ జోడించు',
    saveGRN: 'GRN సేవ్ చేయి',
    
    // Ledger
    balance: 'బ్యాలెన్స్',
    debit: 'డెబిట్',
    creditAmount: 'క్రెడిట్',
    recordPayment: 'చెల్లింపు నమోదు చేయి',
    paymentHistory: 'చెల్లింపు చరిత్ర',
    totalReceivable: 'మొత్తం రాబడి',
    totalPayable: 'మొత్తం చెల్లించవలసినది',
    
    // Bills History
    billNumber: 'బిల్ నం.',
    estimationNumber: 'అంచనా నం.',
    dateTime: 'తేదీ & సమయం',
    items: 'ఐటమ్‌లు',
    bills: 'బిల్లులు',
    estimations: 'అంచనాలు',
    fromDate: 'నుండి తేదీ',
    toDate: 'వరకు తేదీ',
    noBillsFound: 'బిల్లులు కనుగొనబడలేదు',
    noEstimationsFound: 'అంచనాలు కనుగొనబడలేదు',
    
    // Form Fields
    name: 'పేరు',
    mobile: 'మొబైల్',
    email: 'ఇమెయిల్',
    address: 'చిరునామా',
    city: 'నగరం',
    gstNumber: 'GST నంబర్',
    pin: 'PIN',
    
    // Messages
    successSaved: 'విజయవంతంగా సేవ్ చేయబడింది',
    successDeleted: 'విజయవంతంగా తొలగించబడింది',
    errorOccurred: 'లోపం సంభవించింది',
    confirmDelete: 'మీరు తొలగించాలనుకుంటున్నారా?',
    
    // Print
    taxInvoice: 'పన్ను ఇన్వాయిస్',
    estimationDoc: 'అంచనా',
    billTo: 'బిల్ గ్రహీత',
    gstSummary: 'GST సారాంశం',
    cgst: 'CGST',
    sgst: 'SGST',
    thankYou: 'కొనుగోలుకు ధన్యవాదాలు!',
    poweredBy: 'GPOS ద్వారా',
    
    // Language
    selectLanguage: 'భాష ఎంచుకోండి',
    languageChanged: 'భాష విజయవంతంగా మార్చబడింది',
  },
  
  kn: {
    // Common - Kannada
    save: 'ಉಳಿಸಿ',
    cancel: 'ರದ್ದುಮಾಡಿ',
    delete: 'ಅಳಿಸಿ',
    edit: 'ಎಡಿಟ್',
    add: 'ಸೇರಿಸಿ',
    search: 'ಹುಡುಕಿ',
    loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
    actions: 'ಕ್ರಿಯೆಗಳು',
    yes: 'ಹೌದು',
    no: 'ಇಲ್ಲ',
    confirm: 'ದೃಢೀಕರಿಸಿ',
    close: 'ಮುಚ್ಚಿ',
    back: 'ಹಿಂದೆ',
    next: 'ಮುಂದೆ',
    submit: 'ಸಲ್ಲಿಸಿ',
    clear: 'ಕ್ಲಿಯರ್',
    filter: 'ಫಿಲ್ಟರ್',
    reset: 'ರೀಸೆಟ್',
    view: 'ವೀಕ್ಷಿಸಿ',
    print: 'ಪ್ರಿಂಟ್',
    download: 'ಡೌನ್‌ಲೋಡ್',
    share: 'ಹಂಚಿ',
    
    // Navigation
    dashboard: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
    pos: 'POS',
    products: 'ಉತ್ಪನ್ನಗಳು',
    cashRegister: 'ನಗದು ರಿಜಿಸ್ಟರ್',
    expenses: 'ವೆಚ್ಚಗಳು',
    grnEntry: 'GRN ಎಂಟ್ರಿ',
    stockManagement: 'ಸ್ಟಾಕ್ ನಿರ್ವಹಣೆ',
    customerLedger: 'ಗ್ರಾಹಕ ಖಾತೆ',
    supplierLedger: 'ಪೂರೈಕೆದಾರ ಖಾತೆ',
    billsHistory: 'ಬಿಲ್ ಇತಿಹಾಸ',
    reports: 'ವರದಿಗಳು',
    settings: 'ಸೆಟ್ಟಿಂಗ್ಸ್',
    logout: 'ಲಾಗ್ಔಟ್',
    
    // Settings Menu
    businessProfile: 'ವ್ಯಾಪಾರ ಪ್ರೊಫೈಲ್',
    categorySettings: 'ವರ್ಗ ಸೆಟ್ಟಿಂಗ್ಸ್',
    taxGroupSettings: 'ತೆರಿಗೆ ಗುಂಪು ಸೆಟ್ಟಿಂಗ್ಸ್',
    supplierSettings: 'ಪೂರೈಕೆದಾರ ಸೆಟ್ಟಿಂಗ್ಸ್',
    customerSettings: 'ಗ್ರಾಹಕ ಸೆಟ್ಟಿಂಗ್ಸ್',
    cashierSettings: 'ಕ್ಯಾಶಿಯರ್ ಸೆಟ್ಟಿಂಗ್ಸ್',
    expenseCategories: 'ವೆಚ್ಚ ವರ್ಗಗಳು',
    billSettings: 'ಬಿಲ್ ಸೆಟ್ಟಿಂಗ್ಸ್',
    unitSettings: 'ಯೂನಿಟ್ ಸೆಟ್ಟಿಂಗ್ಸ್',
    languageSettings: 'ಭಾಷಾ ಸೆಟ್ಟಿಂಗ್ಸ್',
    
    // POS Billing
    billing: 'ಬಿಲ್ಲಿಂಗ್',
    searchProducts: 'ಉತ್ಪನ್ನಗಳನ್ನು ಹುಡುಕಿ...',
    cart: 'ಕಾರ್ಟ್',
    emptyCart: 'ಕಾರ್ಟ್ ಖಾಲಿಯಾಗಿದೆ',
    addItemsToStart: 'ಬಿಲ್ಲಿಂಗ್ ಪ್ರಾರಂಭಿಸಲು ಐಟಂಗಳನ್ನು ಸೇರಿಸಿ',
    quantity: 'ಪ್ರಮಾಣ',
    price: 'ಬೆಲೆ',
    total: 'ಒಟ್ಟು',
    subtotal: 'ಉಪ ಮೊತ್ತ',
    discount: 'ರಿಯಾಯಿತಿ',
    tax: 'ತೆರಿಗೆ',
    grandTotal: 'ಗ್ರಾಂಡ್ ಟೋಟಲ್',
    payNow: 'ಈಗ ಪಾವತಿಸಿ',
    holdBill: 'ಬಿಲ್ ಹೋಲ್ಡ್',
    clearCart: 'ಕಾರ್ಟ್ ಕ್ಲಿಯರ್',
    customer: 'ಗ್ರಾಹಕ',
    selectCustomer: 'ಗ್ರಾಹಕರನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    guest: 'ಅತಿಥಿ',
    addNewCustomer: 'ಹೊಸ ಗ್ರಾಹಕರನ್ನು ಸೇರಿಸಿ',
    estimation: 'ಅಂದಾಜು',
    estimationMode: 'ಅಂದಾಜು ಮೋಡ್',
    stockNotAffected: 'ಸ್ಟಾಕ್ ಪರಿಣಾಮ ಬೀರುವುದಿಲ್ಲ',
    createEstimation: 'ಅಂದಾಜು ರಚಿಸಿ',
    
    // Payment
    payment: 'ಪಾವತಿ',
    paymentMode: 'ಪಾವತಿ ಮೋಡ್',
    cash: 'ನಗದು',
    card: 'ಕಾರ್ಡ್',
    upi: 'UPI',
    credit: 'ಕ್ರೆಡಿಟ್',
    amountPaid: 'ಪಾವತಿಸಿದ ಮೊತ್ತ',
    changeReturn: 'ಚಿಲ್ಲರೆ',
    completePayment: 'ಪಾವತಿ ಪೂರ್ಣಗೊಳಿಸಿ',
    
    // Form Fields
    name: 'ಹೆಸರು',
    mobile: 'ಮೊಬೈಲ್',
    email: 'ಇಮೇಲ್',
    address: 'ವಿಳಾಸ',
    city: 'ನಗರ',
    gstNumber: 'GST ಸಂಖ್ಯೆ',
    pin: 'PIN',
    
    // Messages
    successSaved: 'ಯಶಸ್ವಿಯಾಗಿ ಉಳಿಸಲಾಗಿದೆ',
    successDeleted: 'ಯಶಸ್ವಿಯಾಗಿ ಅಳಿಸಲಾಗಿದೆ',
    errorOccurred: 'ದೋಷ ಸಂಭವಿಸಿದೆ',
    confirmDelete: 'ನೀವು ಅಳಿಸಲು ಬಯಸುವಿರಾ?',
    
    // Print
    taxInvoice: 'ತೆರಿಗೆ ಇನ್ವಾಯ್ಸ್',
    estimationDoc: 'ಅಂದಾಜು',
    billTo: 'ಬಿಲ್ ಪಡೆಯುವವರು',
    gstSummary: 'GST ಸಾರಾಂಶ',
    cgst: 'CGST',
    sgst: 'SGST',
    thankYou: 'ಖರೀದಿಗೆ ಧನ್ಯವಾದಗಳು!',
    poweredBy: 'GPOS ಮೂಲಕ',
    
    // Language
    selectLanguage: 'ಭಾಷೆ ಆಯ್ಕೆಮಾಡಿ',
    languageChanged: 'ಭಾಷೆ ಯಶಸ್ವಿಯಾಗಿ ಬದಲಾಗಿದೆ',
    
    // Products
    productName: 'ಉತ್ಪನ್ನ ಹೆಸರು',
    sku: 'SKU',
    barcode: 'ಬಾರ್‌ಕೋಡ್',
    category: 'ವರ್ಗ',
    mrp: 'MRP',
    basePrice: 'ಮೂಲ ಬೆಲೆ',
    sellingPrice: 'ಮಾರಾಟ ಬೆಲೆ',
    currentStock: 'ಪ್ರಸ್ತುತ ಸ್ಟಾಕ್',
    stockAlert: 'ಸ್ಟಾಕ್ ಎಚ್ಚರಿಕೆ',
    taxGroup: 'ತೆರಿಗೆ ಗುಂಪು',
    addProduct: 'ಉತ್ಪನ್ನ ಸೇರಿಸಿ',
    editProduct: 'ಉತ್ಪನ್ನ ಎಡಿಟ್',
    noProducts: 'ಉತ್ಪನ್ನಗಳಿಲ್ಲ',
    
    // Cash Register
    openRegister: 'ರಿಜಿಸ್ಟರ್ ತೆರೆಯಿರಿ',
    closeRegister: 'ರಿಜಿಸ್ಟರ್ ಮುಚ್ಚಿ',
    openingBalance: 'ಆರಂಭಿಕ ಬ್ಯಾಲೆನ್ಸ್',
    closingBalance: 'ಮುಕ್ತಾಯ ಬ್ಯಾಲೆನ್ಸ್',
    expectedBalance: 'ನಿರೀಕ್ಷಿತ ಬ್ಯಾಲೆನ್ಸ್',
    actualBalance: 'ನಿಜವಾದ ಬ್ಯಾಲೆನ್ಸ್',
    difference: 'ವ್ಯತ್ಯಾಸ',
    registerStatus: 'ರಿಜಿಸ್ಟರ್ ಸ್ಥಿತಿ',
    registerClosed: 'ರಿಜಿಸ್ಟರ್ ಮುಚ್ಚಲಾಗಿದೆ',
    registerOpen: 'ರಿಜಿಸ್ಟರ್ ತೆರೆದಿದೆ',
    
    // Expenses
    expenseDate: 'ದಿನಾಂಕ',
    expenseCategory: 'ವರ್ಗ',
    expenseAmount: 'ಮೊತ್ತ',
    expenseDescription: 'ವಿವರಣೆ',
    addExpense: 'ವೆಚ್ಚ ಸೇರಿಸಿ',
    noExpenses: 'ವೆಚ್ಚಗಳಿಲ್ಲ',
    
    // GRN
    grnNumber: 'GRN ಸಂಖ್ಯೆ',
    supplier: 'ಪೂರೈಕೆದಾರ',
    invoiceNumber: 'ಇನ್ವಾಯ್ಸ್ ಸಂಖ್ಯೆ',
    invoiceDate: 'ಇನ್ವಾಯ್ಸ್ ದಿನಾಂಕ',
    addItem: 'ಐಟಂ ಸೇರಿಸಿ',
    saveGRN: 'GRN ಉಳಿಸಿ',
    
    // Ledger
    balance: 'ಬ್ಯಾಲೆನ್ಸ್',
    debit: 'ಡೆಬಿಟ್',
    creditAmount: 'ಕ್ರೆಡಿಟ್',
    recordPayment: 'ಪಾವತಿ ದಾಖಲಿಸಿ',
    paymentHistory: 'ಪಾವತಿ ಇತಿಹಾಸ',
    totalReceivable: 'ಒಟ್ಟು ಪಡೆಯಬೇಕಾದದ್ದು',
    totalPayable: 'ಒಟ್ಟು ಪಾವತಿಸಬೇಕಾದದ್ದು',
    
    // Bills History
    billNumber: 'ಬಿಲ್ ಸಂ.',
    estimationNumber: 'ಅಂದಾಜು ಸಂ.',
    dateTime: 'ದಿನಾಂಕ & ಸಮಯ',
    items: 'ಐಟಂಗಳು',
    bills: 'ಬಿಲ್‌ಗಳು',
    estimations: 'ಅಂದಾಜುಗಳು',
    fromDate: 'ದಿನಾಂಕದಿಂದ',
    toDate: 'ದಿನಾಂಕದವರೆಗೆ',
    noBillsFound: 'ಬಿಲ್‌ಗಳು ಕಂಡುಬಂದಿಲ್ಲ',
    noEstimationsFound: 'ಅಂದಾಜುಗಳು ಕಂಡುಬಂದಿಲ್ಲ',
  },
  
  ml: {
    // Common - Malayalam
    save: 'സേവ് ചെയ്യുക',
    cancel: 'റദ്ദാക്കുക',
    delete: 'ഇല്ലാതാക്കുക',
    edit: 'എഡിറ്റ്',
    add: 'ചേർക്കുക',
    search: 'തിരയുക',
    loading: 'ലോഡ് ചെയ്യുന്നു...',
    actions: 'പ്രവർത്തനങ്ങൾ',
    yes: 'അതെ',
    no: 'ഇല്ല',
    confirm: 'സ്ഥിരീകരിക്കുക',
    close: 'അടയ്ക്കുക',
    back: 'മടങ്ങുക',
    next: 'അടുത്തത്',
    submit: 'സമർപ്പിക്കുക',
    clear: 'ക്ലിയർ',
    filter: 'ഫിൽട്ടർ',
    reset: 'റീസെറ്റ്',
    view: 'കാണുക',
    print: 'പ്രിന്റ്',
    download: 'ഡൗൺലോഡ്',
    share: 'പങ്കിടുക',
    
    // Navigation
    dashboard: 'ഡാഷ്ബോർഡ്',
    pos: 'POS',
    products: 'ഉൽപ്പന്നങ്ങൾ',
    cashRegister: 'ക്യാഷ് രജിസ്റ്റർ',
    expenses: 'ചെലവുകൾ',
    grnEntry: 'GRN എൻട്രി',
    stockManagement: 'സ്റ്റോക്ക് മാനേജ്മെന്റ്',
    customerLedger: 'കസ്റ്റമർ ലെഡ്ജർ',
    supplierLedger: 'സപ്ലയർ ലെഡ്ജർ',
    billsHistory: 'ബിൽ ഹിസ്റ്ററി',
    reports: 'റിപ്പോർട്ടുകൾ',
    settings: 'സെറ്റിംഗ്സ്',
    logout: 'ലോഗൗട്ട്',
    
    // Settings Menu
    businessProfile: 'ബിസിനസ് പ്രൊഫൈൽ',
    categorySettings: 'വിഭാഗം സെറ്റിംഗ്സ്',
    taxGroupSettings: 'നികുതി ഗ്രൂപ്പ് സെറ്റിംഗ്സ്',
    supplierSettings: 'സപ്ലയർ സെറ്റിംഗ്സ്',
    customerSettings: 'കസ്റ്റമർ സെറ്റിംഗ്സ്',
    cashierSettings: 'ക്യാഷിയർ സെറ്റിംഗ്സ്',
    expenseCategories: 'ചെലവ് വിഭാഗങ്ങൾ',
    billSettings: 'ബിൽ സെറ്റിംഗ്സ്',
    unitSettings: 'യൂണിറ്റ് സെറ്റിംഗ്സ്',
    languageSettings: 'ഭാഷ സെറ്റിംഗ്സ്',
    
    // POS Billing
    billing: 'ബില്ലിംഗ്',
    searchProducts: 'ഉൽപ്പന്നങ്ങൾ തിരയുക...',
    cart: 'കാർട്ട്',
    emptyCart: 'കാർട്ട് ശൂന്യമാണ്',
    addItemsToStart: 'ബില്ലിംഗ് ആരംഭിക്കാൻ ഇനങ്ങൾ ചേർക്കുക',
    quantity: 'അളവ്',
    price: 'വില',
    total: 'ആകെ',
    subtotal: 'ഉപ ആകെ',
    discount: 'ഡിസ്കൗണ്ട്',
    tax: 'നികുതി',
    grandTotal: 'ഗ്രാൻഡ് ടോട്ടൽ',
    payNow: 'ഇപ്പോൾ അടയ്ക്കുക',
    holdBill: 'ബിൽ ഹോൾഡ്',
    clearCart: 'കാർട്ട് ക്ലിയർ',
    customer: 'കസ്റ്റമർ',
    selectCustomer: 'കസ്റ്റമറെ തിരഞ്ഞെടുക്കുക',
    guest: 'അതിഥി',
    addNewCustomer: 'പുതിയ കസ്റ്റമർ ചേർക്കുക',
    estimation: 'എസ്റ്റിമേഷൻ',
    estimationMode: 'എസ്റ്റിമേഷൻ മോഡ്',
    stockNotAffected: 'സ്റ്റോക്ക് ബാധിക്കില്ല',
    createEstimation: 'എസ്റ്റിമേഷൻ ഉണ്ടാക്കുക',
    
    // Payment
    payment: 'പേയ്മെന്റ്',
    paymentMode: 'പേയ്മെന്റ് മോഡ്',
    cash: 'ക്യാഷ്',
    card: 'കാർഡ്',
    upi: 'UPI',
    credit: 'ക്രെഡിറ്റ്',
    amountPaid: 'അടച്ച തുക',
    changeReturn: 'ബാക്കി',
    completePayment: 'പേയ്മെന്റ് പൂർത്തിയാക്കുക',
    
    // Form Fields
    name: 'പേര്',
    mobile: 'മൊബൈൽ',
    email: 'ഇമെയിൽ',
    address: 'വിലാസം',
    city: 'നഗരം',
    gstNumber: 'GST നമ്പർ',
    pin: 'PIN',
    
    // Messages
    successSaved: 'വിജയകരമായി സേവ് ചെയ്തു',
    successDeleted: 'വിജയകരമായി ഇല്ലാതാക്കി',
    errorOccurred: 'ഒരു പിശക് സംഭവിച്ചു',
    confirmDelete: 'നിങ്ങൾക്ക് ഇല്ലാതാക്കണമെന്ന് ഉറപ്പാണോ?',
    
    // Print
    taxInvoice: 'ടാക്സ് ഇൻവോയ്സ്',
    estimationDoc: 'എസ്റ്റിമേഷൻ',
    billTo: 'ബിൽ ലഭ്യമാക്കുന്നയാൾ',
    gstSummary: 'GST സംഗ്രഹം',
    cgst: 'CGST',
    sgst: 'SGST',
    thankYou: 'വാങ്ങിയതിന് നന്ദി!',
    poweredBy: 'GPOS വഴി',
    
    // Language
    selectLanguage: 'ഭാഷ തിരഞ്ഞെടുക്കുക',
    languageChanged: 'ഭാഷ വിജയകരമായി മാറ്റി',
    
    // Products
    productName: 'ഉൽപ്പന്നത്തിന്റെ പേര്',
    sku: 'SKU',
    barcode: 'ബാർകോഡ്',
    category: 'വിഭാഗം',
    mrp: 'MRP',
    basePrice: 'അടിസ്ഥാന വില',
    sellingPrice: 'വിൽപ്പന വില',
    currentStock: 'നിലവിലെ സ്റ്റോക്ക്',
    stockAlert: 'സ്റ്റോക്ക് അലർട്ട്',
    taxGroup: 'നികുതി ഗ്രൂപ്പ്',
    addProduct: 'ഉൽപ്പന്നം ചേർക്കുക',
    editProduct: 'ഉൽപ്പന്നം എഡിറ്റ്',
    noProducts: 'ഉൽപ്പന്നങ്ങൾ ഇല്ല',
    
    // Cash Register
    openRegister: 'രജിസ്റ്റർ തുറക്കുക',
    closeRegister: 'രജിസ്റ്റർ അടയ്ക്കുക',
    openingBalance: 'ആരംഭ ബാലൻസ്',
    closingBalance: 'ക്ലോസിംഗ് ബാലൻസ്',
    expectedBalance: 'പ്രതീക്ഷിക്കുന്ന ബാലൻസ്',
    actualBalance: 'യഥാർത്ഥ ബാലൻസ്',
    difference: 'വ്യത്യാസം',
    registerStatus: 'രജിസ്റ്റർ സ്റ്റാറ്റസ്',
    registerClosed: 'രജിസ്റ്റർ അടച്ചു',
    registerOpen: 'രജിസ്റ്റർ തുറന്നിരിക്കുന്നു',
    
    // Expenses
    expenseDate: 'തീയതി',
    expenseCategory: 'വിഭാഗം',
    expenseAmount: 'തുക',
    expenseDescription: 'വിവരണം',
    addExpense: 'ചെലവ് ചേർക്കുക',
    noExpenses: 'ചെലവുകൾ ഇല്ല',
    
    // GRN
    grnNumber: 'GRN നമ്പർ',
    supplier: 'സപ്ലയർ',
    invoiceNumber: 'ഇൻവോയ്സ് നമ്പർ',
    invoiceDate: 'ഇൻവോയ്സ് തീയതി',
    addItem: 'ഇനം ചേർക്കുക',
    saveGRN: 'GRN സേവ്',
    
    // Ledger
    balance: 'ബാലൻസ്',
    debit: 'ഡെബിറ്റ്',
    creditAmount: 'ക്രെഡിറ്റ്',
    recordPayment: 'പേയ്മെന്റ് രേഖപ്പെടുത്തുക',
    paymentHistory: 'പേയ്മെന്റ് ഹിസ്റ്ററി',
    totalReceivable: 'ആകെ ലഭിക്കേണ്ടത്',
    totalPayable: 'ആകെ നൽകേണ്ടത്',
    
    // Bills History
    billNumber: 'ബിൽ നം.',
    estimationNumber: 'എസ്റ്റിമേഷൻ നം.',
    dateTime: 'തീയതി & സമയം',
    items: 'ഇനങ്ങൾ',
    bills: 'ബില്ലുകൾ',
    estimations: 'എസ്റ്റിമേഷനുകൾ',
    fromDate: 'മുതൽ തീയതി',
    toDate: 'വരെ തീയതി',
    noBillsFound: 'ബില്ലുകൾ കണ്ടെത്തിയില്ല',
    noEstimationsFound: 'എസ്റ്റിമേഷനുകൾ കണ്ടെത്തിയില്ല',
  }
};

// Available languages
export const languages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
  { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
  { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
  { code: 'ml', name: 'Malayalam', nativeName: 'മലയാളം' },
];

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get saved language from localStorage or default to 'en'
    return localStorage.getItem('pos_language') || 'en';
  });

  useEffect(() => {
    localStorage.setItem('pos_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  };

  const changeLanguage = (langCode) => {
    setLanguage(langCode);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, languages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
